import { Component, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService, LoaderType } from 'src/app/service/loader.service';
import { NgClass } from '@angular/common';
import { CdsProgressModule } from '@cds/ng-web-components/progress';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: true,
    imports: [NgClass, CdsProgressModule]
})
export class LoaderComponent implements OnDestroy {
  private loaderService = inject(LoaderService);

  isLoading: boolean = false;
  loaderType: LoaderType = 'NONE';
  subscription: Subscription;
  appearAsModal:boolean = false;
  loaderText!:string;
  diameter:number = 60;

  constructor() {
    this.subscription = this.loaderService.isLoading.subscribe((loaderConfig) => {
      this.isLoading = loaderConfig._isLoading || false;
      this.loaderType = loaderConfig.loaderType;
      this.appearAsModal = loaderConfig.appearAsModal as unknown as boolean;
      this.loaderText = loaderConfig.loaderText as unknown as string;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}
